import React from 'react'
import StatePicker from "../../../../common/state-picker";
import SecondaryChainSelect from "./secondary-chain-select";
import LocationSelect from "./location-select";

export default function StandardRuleSourceSelect({ ruleset, rule, updateField }) {
  switch(rule.locations_by) {
    case 'by_state':
      return !rule.state_name ? "All States" : (
        <StatePicker
          className={`h-[40px] text-xs border-none focus:outline-none focus:ring-0 focus:border-none`}
          state={rule.state_name}
          update={(newState) => {
            updateField('state_name', newState)
          }}
        />
      )
    case 'by_location':
      return (
        <LocationSelect
          className="h-[40px] text-xs w-full border-none focus:outline-none focus:ring-0 focus:border-none pl-0 text-sm"
          location={rule.location}
          chain_id={ruleset.chain_id}
          updateField={updateField}
        />
      )
    case 'is_one9':
      return 'All One9';
    case 'is_express':
      return 'All Express';
    case 'by_secondary_chain':
      return (
        <SecondaryChainSelect
          secondary_chain_id={rule.secondary_chain_id}
          chain_id={ruleset.chain_id}
          className="h-[40px] text-xs border-none focus:outline-none focus:ring-0 focus:border-none"
          updateField={updateField}
        />
      )
  }
}
